import { Box, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { translate } from '../../../i18n';
import { CourtTemporaryBlockadeReason } from '../../../models/court/dto/court-temporary-blockade.dto';
type Props = { selectedReason: CourtTemporaryBlockadeReason; setSelectedReason: (loc: CourtTemporaryBlockadeReason) => void };
const reasons = [{
    id: CourtTemporaryBlockadeReason.OTHER,
    name: translate('courts.blockade.other')
}, {
    id: CourtTemporaryBlockadeReason.COURT_MAINTENANCE,
    name: translate('courts.blockade.maintenance')
}, {
    id: CourtTemporaryBlockadeReason.EXTERNAL_RESERVATION,
    name: translate('courts.blockade.external_reservation')
}, {
    id: CourtTemporaryBlockadeReason.PENDING_PAYMENT,
    name: translate('courts.blockade.pending_payment')
}]
export function courtBlockadeReasonEnumToString(reason: CourtTemporaryBlockadeReason) {
    return reasons.find(item => item.id === reason)?.name ?? reason;
}
export default function BlockadeReasonPicker({ selectedReason, setSelectedReason }: Props) {
    return (
        <Box>
            <RadioGroup onChange={setSelectedReason} value={selectedReason}>
                <Stack direction='row'>
                    {reasons.map(reason => <Radio key={reason.id} value={reason.id}>{reason.name}</Radio>)}
                </Stack>
            </RadioGroup>
        </Box>
    );
}
